//
// AbstractValueConstraintType.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractConstraintType";

var AbstractValueConstraintType = createModule("BIRD::AbstractValueConstraintType", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::AbstractConstraintType"], EventDispatcher, [
    ,
    {
        userValuesAllowed: 2,
        selectionOrdered: 4,
        minValueCount: 4,
        missingAllowed: 2,
        allAllowed: 2,
        maxValueCount: 4,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default AbstractValueConstraintType;
